import * as Html from "../../util/Html.ts";

export {init}

function init(obj){
  obj.css('display','inline-block')
  obj.css('transform-origin',"left")
  fitIt(obj)
}


function fitIt(obj){
  var ratio = 0.9*obj.parent().width()/obj.width();
  if(ratio<1){
    obj.css("transform","scale("+ratio+")")
  }
}
Html.registerWidget('widget/animation/autofit',{init:init})